// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2c6ET","detailsBorder":"styles_detailsBorder__3rf5e"};